import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { compose } from 'redux';
import { IconSpinner, Modal } from '../../../../components';
import { manageDisableScrolling } from '../../../../ducks/ui.duck';
import {
  createCommentBodyHelper,
  getInitialValuesForComments,
  reverseTransformContent,
  transformRawContent,
} from '../../../../util/circleHelper';
import {
  advancedSearch,
  editCommentForPost,
  editReplyComment,
  toggelDocumentReducer,
  toggelGiphyReducer,
  toggelImageReducer,
  toggelVideoReducer,
  toggleEmoji,
} from '../../CircleCommunityPage.duck';
import EditCommentForm from './EditCommentForm';
import css from './EditCommentModal.module.css';
import { CompositeDecorator, EditorState, Modifier, convertFromRaw, convertToRaw } from 'draft-js';

const mentionStrategy = (contentBlock, callback, contentState) => {
  const text = contentBlock.getText();
  let matchArr, start;
  const regex = /@\w+/g; // Detect mentions starting with '@'
  while ((matchArr = regex.exec(text)) !== null) {
    start = matchArr.index;
    callback(start, start + matchArr[0].length);
  }
};
const Mention = (props) => (
  <span style={{ backgroundColor: "#e8f5ff", color: "#0073e6" }}>
    {props.children}
  </span>
);

const compositeDecorator = new CompositeDecorator([
  {
    strategy: mentionStrategy,
    component: Mention,
  },
]);

const EditCommentModal = props => {
  const dispatch = useDispatch();
  const {
    onEditCommentClick,
    editCommentData,
    onGiphyChange,
    onDocumentClick,
    onImageClick,
    onVideoClick,
    isGiphyOpen,
    isDocumentModal,
    isImageModal,
    isVideoUpload,
    requestCreateComment,
    requestDirectUpload,
    onEmojiClick,
    isEmojiOpen,
    requestEditComment,
    onAdvancedSearch,
    advancedSearchData,
    currentUser,
  } = props;

  const { tiptap_body } = editCommentData || {};
  const { body, attachments } = tiptap_body || {};
  const rawContent = reverseTransformContent(body);
  // Convert the raw content to ContentState
  const contentState = convertFromRaw(rawContent);
  const [editorState, setEditorState] = useState(
    EditorState.createWithContent(contentState, compositeDecorator)
  );
  const [formOldValues, setFormOldValues] = useState(() =>
    getInitialValuesForComments(editCommentData)
  );

  useEffect(() => {
    if (body) {
      setEditorState(EditorState.createWithContent(contentState, compositeDecorator))
    }
    setFormOldValues(() => getInitialValuesForComments(editCommentData));
  }, [editCommentData]);

  const { post_id: postId, id: commentID, parent_comment_id: parentCommentId } = editCommentData || {};

  const handleEditComment = async values => {
    const contentState = editorState?.getCurrentContent();
    const rawContent = convertToRaw(contentState); // Convert to raw JS object
    const formateEditor = transformRawContent(rawContent);
    const params = createCommentBodyHelper(values, formateEditor);
    if (parentCommentId) {
      await dispatch(editReplyComment(params, parentCommentId, commentID));
    } else {
      await dispatch(editCommentForPost(params, postId, commentID));
    }
    onEditCommentClick();
    setFormOldValues({});
    setEditorState(EditorState.createEmpty(compositeDecorator))
  };

  const handleCloseModal = () => {
    onEditCommentClick();
    setFormOldValues({});
  };

  const insertEmoji = (emoji) => {
    const currentContent = editorState.getCurrentContent();
    const selection = editorState.getSelection();

    // Make sure the insertion is at the cursor's current position
    if (!selection.isCollapsed()) {
      const newContentState = Modifier.replaceText(
        currentContent,
        selection,
        emoji
      );
      const newEditorState = EditorState.push(editorState, newContentState, "insert-characters");
      setEditorState(newEditorState);
    } else {
      // If the selection is collapsed (no text selected), append the emoji
      const newContentState = Modifier.insertText(
        currentContent,
        selection,
        emoji
      );
      const newEditorState = EditorState.push(editorState, newContentState, "insert-characters");
      setEditorState(newEditorState);
    }
    onEmojiClick(false);
  };

  return (
    <>
      <Modal
        id="editCommentModal"
        isOpen={!!editCommentData}
        onClose={handleCloseModal}
        onManageDisableScrolling={manageDisableScrolling}
        className={css.editCommentModal}
      >
        {requestEditComment ? <IconSpinner type="true" /> : null}
       {editCommentData ? <EditCommentForm
          editorState={editorState}
          setEditorState={setEditorState}
          insertEmoji={insertEmoji}
          onAdvancedSearch={onAdvancedSearch}
          advancedSearchData={advancedSearchData}
          initialValues={formOldValues}
          onSubmit={handleEditComment}
          formOldValues={formOldValues}
          setFormOldValues={setFormOldValues}
          requestCreateComment={requestEditComment || requestCreateComment}
          requestDirectUpload={requestDirectUpload}
          onGiphyChange={onGiphyChange}
          onDocumentClick={onDocumentClick}
          onImageClick={onImageClick}
          onVideoClick={onVideoClick}
          onEmojiClick={onEmojiClick}
          isEmojiOpen={isEmojiOpen}
          isGiphyOpen={isGiphyOpen}
          isDocumentModal={isDocumentModal}
          isImageModal={isImageModal}
          isVideoUpload={isVideoUpload}
          currentUser={currentUser}
          avatar_url={null}
        /> : null}
      </Modal>
    </>
  );
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const {
    isGiphyOpen,
    isDocumentModal,
    isImageModal,
    isVideoUpload,
    requestCreateComment,
    requestDirectUpload,
    isEmojiOpen,
    requestEditComment, advancedSearchData
  } = state.CircleCommunityPage;

  return {
    isGiphyOpen,
    isDocumentModal,
    isImageModal,
    isVideoUpload,
    requestCreateComment,
    requestDirectUpload,
    isEmojiOpen,
    requestEditComment,
    advancedSearchData,
    currentUser,
  };
};
const mapDispatchToProps = dispatch => ({
  onGiphyChange: () => dispatch(toggelGiphyReducer()),
  onDocumentClick: () => dispatch(toggelDocumentReducer()),
  onImageClick: () => dispatch(toggelImageReducer()),
  onVideoClick: () => dispatch(toggelVideoReducer()),
  onEmojiClick: params => dispatch(toggleEmoji(params)),
  onAdvancedSearch: params => dispatch(advancedSearch(params))
});
export default compose(connect(mapStateToProps, mapDispatchToProps))(EditCommentModal);
